import {Typography} from '@sollapay/ui/components';
import {formatDateLocalized} from '@sollapay/utils';
import {Trans, useTranslation} from 'react-i18next';

import type {FC} from 'react';

export interface SupplementaryGeneralDeclarationProps {
  /** ISO date the main declaration was signed — rendered as '—' when absent. */
  signedAt?: string | null;
}

const PREFIX = 'activation.packages.compliance.supplementary';

export const SupplementaryGeneralDeclaration: FC<SupplementaryGeneralDeclarationProps> = ({
  signedAt
}) => {
  const {t, i18n} = useTranslation('trustAccounts');
  const signedDate = signedAt ? formatDateLocalized(signedAt, i18n.language) : '—';

  return (
    <div className="flex flex-col gap-3" data-slot="supplementary-general-declaration">
      <Typography weight="semibold" className="whitespace-normal">
        {t(`${PREFIX}.generalDeclaration.heading`)}
      </Typography>
      <div className="rounded-xl border border-border bg-background-secondary px-4 py-3">
        <Typography as="div" size="sm" color="secondary" className="whitespace-normal">
          <Trans
            i18nKey={`${PREFIX}.generalDeclaration.body`}
            ns="trustAccounts"
            values={{date: signedDate}}
            components={{b: <strong className="font-semibold text-fg" />}}
          />
        </Typography>
      </div>
    </div>
  );
};
